import styled from 'styled-components'

import { elementStyle } from 'styles/element-style'

export const Wrapper = styled.div<IElement>`
  ${elementStyle}
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  width: 100%;
  margin-left: -15px;

  @media (max-width: 991px) {
    margin-left: 0;
    flex-wrap: wrap;
    justify-content: flex-start;
    row-gap: 25px;
  }
`

export const ItemWrapper = styled.span<IElement>`
  ${elementStyle}
  width: 125px;
  display: flex;
  flex-direction: column;
  align-items: center;
`

export const TitleWrapper = styled.span`
  text-align: center;
`

export const IconWrapper = styled.span`
  width: 40px;
  height: 40px;
`
